
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiRadarShortPulseIec as ObiRadarShortPulseIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-radar-short-pulse-iec.js';
 
 
 

 
 export const ObiRadarShortPulseIec = createComponent({
   react: React,
   tagName: 'obi-radar-short-pulse-iec',
   elementClass: ObiRadarShortPulseIecElement,
   events: {
     
   }
  });
 
 